import { useParams } from 'react-router-dom';
import { dateSort, projNumSort } from '../../utilities/services/sortConditionally';
// import DeleteApplication from '../DeleteApplication/DeleteApplication';
import PatentApplicationsFilter from '../PatentApplicationsFilter/PatentApplicationsFilter';
import PatentApplicationsListItem from '../PatentApplicationsListItem/PatentApplicationsListItem';
// import UpdateApplication from '../UpdateApplication/UpdateApplication';
import './PatentApplicationsList.css';

export default function PatentApplicationsList({user, patentApplicationPreferences, patentApplications, updatePatentApplications, sortHeader, setSortHeader, sortOrder, setSortOrder, toggleNotifications, isMobile}) {
    const datesArray = ['earliestPriorityDate', 'filingDate', 'plannedFilingDate', 'officialFilingDate', 'nationalEntryDate', 'publicationDate', 'estimatedFirstOfficeActionDate', 'officialOfficeActionDate', 'allowanceDate', 'examinerInterviewDate', 'RCEFiledDate', 'issueFeePaymentDate', 'issueDate', 'maintenanceFeeDueDate', 'expirationDate', 'abandonedDate']
    const params = useParams();

    const handleTableHeaderClick = (evt) => {
        const header = evt.target.id;
        const newSortOrder = sortOrder === 'asc' ? 'desc' : 'asc'
        setSortHeader(header);
        setSortOrder(newSortOrder);

        let sortedApplications = [...patentApplications];
        if (header === 'RPNumber') {
            sortedApplications = projNumSort(newSortOrder, header, sortedApplications);
        } else if (datesArray.includes(header)) {
            sortedApplications = dateSort(newSortOrder, header, sortedApplications);
        } else {
            sortedApplications.sort((a, b) => {
            if (newSortOrder === 'asc') {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) > (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            } else {
                return ((typeof(a[header])==='string' ? a[header].toLowerCase() : a[header]) < (typeof(b[header])==='string' ? b[header].toLowerCase() : b[header])) ? 1 : -1;
            }
            });
        }
        updatePatentApplications(sortedApplications);
    }

    // console.log(patentApplicationPreferences)
  
  
    return (
    <div className='PatentApplicationsList'>
        { !(params.clientID) &&
        <div className='filterContainer'>
            <PatentApplicationsFilter user={user} updatePatentApplications={updatePatentApplications} isMobile={isMobile} sortHeader={sortHeader} />
        </div>
        }
        <div className='patentApplicationsTable'>
          <table className=''>
            { patentApplicationPreferences &&
            <>
            <thead>
                <tr>
                    {!patentApplicationPreferences.includes('RPNumber') &&
                    <th id='RPNumber' onClick={handleTableHeaderClick} className='RPNumber'>
                        <div className='tableHeaderWithArrow'><div>RP Number&nbsp;&nbsp;</div>
                            { sortHeader==='RPNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('applicationNumber') &&
                    <th id='applicationNumber' onClick={handleTableHeaderClick} className='applicationNumber'>
                        <div className='tableHeaderWithArrow'><div>Application Num&nbsp;&nbsp;</div>
                            { sortHeader==='applicationNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('applicationType') &&
                    <th id='applicationType' onClick={handleTableHeaderClick} className='applicationType'>
                        <div className='tableHeaderWithArrow'><div>Application Type&nbsp;&nbsp;</div>
                            { sortHeader==='applicationType'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('filingDate') &&
                    <th id='filingDate' onClick={handleTableHeaderClick} className='filingDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Filing Date&nbsp;&nbsp;</div>
                            { sortHeader==='filingDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('title') &&
                    <th id='title' onClick={handleTableHeaderClick} className='title'>
                        <div className='tableHeaderWithArrow'><div>Title&nbsp;&nbsp;</div>
                            { sortHeader==='title'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('applicationStatus') &&
                    <th id='applicationStatus' onClick={handleTableHeaderClick} className='applicationStatus'>
                        <div className='tableHeaderWithArrow'><div>Application Status&nbsp;&nbsp;</div>
                            { sortHeader==='applicationStatus'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('inventors') &&
                    <th id='inventors' onClick={handleTableHeaderClick} className='inventors'>
                        <div className='tableHeaderWithArrow'><div>Inventors&nbsp;&nbsp;</div>
                            { sortHeader==='inventors'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('clientName') &&
                    <th id='clientName' onClick={handleTableHeaderClick} className='clientName'>
                        <div className='tableHeaderWithArrow'><div>Client&nbsp;&nbsp;</div>
                            { sortHeader==='clientName'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('clientID') &&
                    <th id='clientID' onClick={handleTableHeaderClick} className='clientID'>
                        <div className='tableHeaderWithArrow'><div>Client ID&nbsp;&nbsp;</div>
                            { sortHeader==='clientID'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('applicants') &&
                    <th id='applicants' onClick={handleTableHeaderClick} className='applicants'>
                        <div className='tableHeaderWithArrow'><div>Applicants&nbsp;&nbsp;</div>
                            { sortHeader==='applicants'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('filingFirm') &&
                    <th id='filingFirm' onClick={handleTableHeaderClick} className='filingFirm'>
                        <div className='tableHeaderWithArrow'><div>Filing Firm&nbsp;&nbsp;</div>
                            { sortHeader==='filingFirm'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('firmRefNumber') &&
                    <th id='firmRefNumber' onClick={handleTableHeaderClick} className='firmRefNumber'>
                        <div className='tableHeaderWithArrow'><div>Firm Ref&nbsp;&nbsp;</div>
                            { sortHeader==='firmRefNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('attorney') &&
                    <th id='attorney' onClick={handleTableHeaderClick} className='attorney'>
                        <div className='tableHeaderWithArrow'><div>Attorney&nbsp;&nbsp;</div>
                            { sortHeader==='attorney'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('attorneyRefNumber') &&
                    <th id='attorneyRefNumber' onClick={handleTableHeaderClick} className='attorneyRefNumber'>
                        <div className='tableHeaderWithArrow'><div>Attorney Ref&nbsp;&nbsp;</div>
                            { sortHeader==='attorneyRefNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('contact') &&
                    <th id='contact' onClick={handleTableHeaderClick} className='contact'>
                        <div className='tableHeaderWithArrow'><div>Contact&nbsp;&nbsp;</div>
                            { sortHeader==='contact'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('country') &&
                    <th id='country' onClick={handleTableHeaderClick} className='country'>
                        <div className='tableHeaderWithArrow'><div>Country&nbsp;&nbsp;</div>
                            { sortHeader==='country'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('patentType') &&
                    <th id='patentType' onClick={handleTableHeaderClick} className='patentType'>
                        <div className='tableHeaderWithArrow'><div>Patent Type&nbsp;&nbsp;</div>
                            { sortHeader==='patentType'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('earliestPriorityDate') &&
                    <th id='earliestPriorityDate' onClick={handleTableHeaderClick} className='earliestPriorityDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Earliest Priority&nbsp;&nbsp;</div>
                            { sortHeader==='earliestPriorityDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('earliestPriorityApplicationNumber') &&
                    <th id='earliestPriorityApplicationNumber' onClick={handleTableHeaderClick} className='earliestPriorityApplicationNumber'>
                        <div className='tableHeaderWithArrow'><div>Earliest Priority Application Num&nbsp;&nbsp;</div>
                            { sortHeader==='earliestPriorityApplicationNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('lastAction') &&
                    <th id='lastAction' onClick={handleTableHeaderClick} className='lastAction'>
                        <div className='tableHeaderWithArrow'><div>Last Action&nbsp;&nbsp;</div>
                            { sortHeader==='lastAction'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('nextAction') &&
                    <th id='nextAction' onClick={handleTableHeaderClick} className='nextAction'>
                        <div className='tableHeaderWithArrow'><div>Next Action&nbsp;&nbsp;</div>
                            { sortHeader==='nextAction'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('nextActionDueDate') &&
                    <th id='nextActionDueDate' onClick={handleTableHeaderClick} className='nextActionDueDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Next Action Due&nbsp;&nbsp;</div>
                            { sortHeader==='nextAction'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('entityStatus') &&
                    <th id='entityStatus' onClick={handleTableHeaderClick} className='entityStatus'>
                        <div className='tableHeaderWithArrow'><div>Entity Status&nbsp;&nbsp;</div>
                            { sortHeader==='entityStatus'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('plannedFilingDate') &&
                    <th id='plannedFilingDate' onClick={handleTableHeaderClick} className='plannedFilingDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Filing Planned&nbsp;&nbsp;</div>
                            { sortHeader==='plannedFilingDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('officialFilingDate') &&
                    <th id='officialFilingDate' onClick={handleTableHeaderClick} className='officialFilingDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Official Filing&nbsp;&nbsp;</div>
                            { sortHeader==='officialFilingDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('nationalEntryDate') &&
                    <th id='nationalEntryDate' onClick={handleTableHeaderClick} className='nationalEntryDate dateField'>
                        <div className='tableHeaderWithArrow'><div>National Entry&nbsp;&nbsp;</div>
                            { sortHeader==='nationalEntryDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('publicationDate') &&
                    <th id='publicationDate' onClick={handleTableHeaderClick} className='publicationDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Publication&nbsp;&nbsp;</div>
                            { sortHeader==='publicationDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('estimatedFirstOfficeActionDate') &&
                    <th id='estimatedFirstOfficeActionDate' onClick={handleTableHeaderClick} className='estimatedFirstOfficeActionDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Estimated First Office Action&nbsp;&nbsp;</div>
                            { sortHeader==='estimatedFirstOfficeActionDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('officialOfficeActionDate') &&
                    <th id='officialOfficeActionDate' onClick={handleTableHeaderClick} className='officialOfficeActionDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Official Office Action&nbsp;&nbsp;</div>
                            { sortHeader==='officialOfficeActionDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('allowanceDate') &&
                    <th id='allowanceDate' onClick={handleTableHeaderClick} className='allowanceDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Allowance&nbsp;&nbsp;</div>
                            { sortHeader==='allowanceDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('requestExaminerInterview') &&
                    <th id='requestExaminerInterview' onClick={handleTableHeaderClick} className='requestExaminerInterview'>
                        <div className='tableHeaderWithArrow'><div>Request Examiner Interview&nbsp;&nbsp;</div>
                            { sortHeader==='requestExaminerInterview'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('examinerInterviewDate') &&
                    <th id='examinerInterviewDate' onClick={handleTableHeaderClick} className='examinerInterviewDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Examiner Interview&nbsp;&nbsp;</div>
                            { sortHeader==='examinerInterviewDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('filedRCE') &&
                    <th id='filedRCE' onClick={handleTableHeaderClick} className='filedRCE'>
                        <div className='tableHeaderWithArrow'><div>Filed RCE&nbsp;&nbsp;</div>
                            { sortHeader==='filedRCE'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('RCEFiledDate') &&
                    <th id='RCEFiledDate' onClick={handleTableHeaderClick} className='RCEFiledDate dateField'>
                        <div className='tableHeaderWithArrow'><div>RCE Filing&nbsp;&nbsp;</div>
                            { sortHeader==='RCEFiledDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('issueFeePaymentDate') &&
                    <th id='issueFeePaymentDate' onClick={handleTableHeaderClick} className='issueFeePaymentDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Issue Fee Payment&nbsp;&nbsp;</div>
                            { sortHeader==='issueFeePaymentDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('issueDate') &&
                    <th id='issueDate' onClick={handleTableHeaderClick} className='issueDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Issued&nbsp;&nbsp;</div>
                            { sortHeader==='issueDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('patentNumber') &&
                    <th id='patentNumber' onClick={handleTableHeaderClick} className='patentNumber'>
                        <div className='tableHeaderWithArrow'><div>Patent / Publication Number&nbsp;&nbsp;</div>
                            { sortHeader==='patentNumber'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('maintenanceFeeDueDate') &&
                    <th id='maintenanceFeeDueDate' onClick={handleTableHeaderClick} className='maintenanceFeeDueDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Maintenance Fee Due&nbsp;&nbsp;</div>
                            { sortHeader==='maintenanceFeeDueDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('maintenanceFeeStatus') &&
                    <th id='maintenanceFeeStatus' onClick={handleTableHeaderClick} className='maintenanceFeeStatus'>
                        <div className='tableHeaderWithArrow'><div>Maintenance Fee Status&nbsp;&nbsp;</div>
                            { sortHeader==='maintenanceFeeStatus'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('expirationDate') &&
                    <th id='expirationDate' onClick={handleTableHeaderClick} className='expirationDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Expiration&nbsp;&nbsp;</div>
                            { sortHeader==='expirationDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('abandonedDate') &&
                    <th id='abandonedDate' onClick={handleTableHeaderClick} className='abandonedDate dateField'>
                        <div className='tableHeaderWithArrow'><div>Date Abandoned&nbsp;&nbsp;</div>
                            { sortHeader==='abandonedDate'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('PAIRReg') &&
                    <th id='PAIRReg' onClick={handleTableHeaderClick} className='PAIRReg'>
                        <div className='tableHeaderWithArrow'><div>PAIR Reg&nbsp;&nbsp;</div>
                            { sortHeader==='PAIRReg'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('notes') &&
                    <th id='notes' onClick={handleTableHeaderClick} className='notes'>
                        <div className='tableHeaderWithArrow'><div>Notes&nbsp;&nbsp;</div>
                            { sortHeader==='notes'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('driveFolderLocation') &&
                    <th id='driveFolderLocation' onClick={handleTableHeaderClick} className='driveFolderLocation'>
                        <div className='tableHeaderWithArrow'><div>Folder Location&nbsp;&nbsp;</div>
                            { sortHeader==='driveFolderLocation'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('createdAt') &&
                    <th id='createdAt' onClick={handleTableHeaderClick} className='createdAt dateField'>
                        <div className='tableHeaderWithArrow'><div>Creation&nbsp;&nbsp;</div>
                            { sortHeader==='createdAt'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                    {!patentApplicationPreferences.includes('updatedAt') &&
                    <th id='updatedAt' onClick={handleTableHeaderClick} className='updatedAt dateField'>
                        <div className='tableHeaderWithArrow'><div>Last Update&nbsp;&nbsp;</div>
                            { sortHeader==='updatedAt'?
                            <>
                            {sortOrder==='asc' ?
                            <div>
                                <div className='sortIndicatorActive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            : 
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorActive'>&#9660;</div>
                            </div>
                            }
                            </>
                            :
                            <div>
                                <div className='sortIndicatorInactive'>&#9650;</div>
                                <div className='sortIndicatorInactive'>&#9660;</div>
                            </div>
                            }
                        </div>
                    </th>
                    }
                </tr>
            </thead>
            <tbody>
                { patentApplications.length === 0 ?
                <tr>
                <td colSpan='12' className='noApplications text-center'>No Applications Found</td>
                </tr>
                :
                <>
                {patentApplications.map(application => (
                <PatentApplicationsListItem user={user} key={application._id} applicationItem={application} updateApplications={updatePatentApplications} isMobile={isMobile} toggleNotifications={toggleNotifications} patentApplicationPreferences={patentApplicationPreferences} />
                ))}
                </>
                }
            </tbody>
            </>
            }
          </table>
        </div>
        <div className='footer'>
          <div>
            page count
          </div>
          <div>
            toggle
          </div>
        </div>
    </div>
  )
}
